import React from 'react';
import { SegmentSliceProps } from './types';
import style from './style.module.scss';
import cx from 'classnames';
import { Col, Row } from 'react-bootstrap';
import { pluralize } from 'utilities/pluralize';
import { paths } from 'config/path_helpers';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import Play from '../../assets/play.svg';
import Pencil from '../../assets/pencil.svg';
import SingleDiamond from '../../assets/single_diamond.svg';
import DoubleDiamond from '../../assets/double_diamond.svg';
import { LinkButton } from '@magoosh/lib/button';
import ContextualLink from '@magoosh/gre/app/contextual_link';

export const SegmentSlice: React.FC<SegmentSliceProps> = (props) => {
  const { number, title, estimatedTimeMinutes, blocks, segmentIsLocked, showUpgradeModal } = props;

  return (
    <div className={cx(style.segmentSlice, 'u-margin-H-l u-margin-B-m')}>
      <Row>
        <Col md={12}>
          <h3 className={cx(style.number, 'u-margin-R-s')}>
            <strong>{number}</strong>
          </h3>
        </Col>
      </Row>
      <Row>
        <Col md={3} className={style.itemHeadline}>
          <div>
            <h4 className="u-margin-B-n">{title}</h4>
            <p>
              <small>{pluralize(estimatedTimeMinutes, 'Minute')}</small>
            </p>
          </div>
        </Col>
        <Col md={6} mdOffset={3} className={style.itemWrapper}>
          {blocks.map((block, index) => {
            let blockProps;
            if (block.type === 'lesson') {
              blockProps = {
                icon: block.completed ? (
                  <FontAwesomeIcon icon={'check-circle'} />
                ) : (
                  <img alt="Play Button" src={Play} />
                ),
                title: `Lesson Video (${pluralize(block.estimatedTimeMinutes, 'minute')})`,
                action: segmentIsLocked
                  ? () => showUpgradeModal(true)
                  : `${paths.lesson(block.lessonId)}?study_item=${block.id}`
              };
            } else if (block.type === 'concept') {
              const promptCount = Math.min(block.sessionPromptCount, block.blockPromptCount);
              blockProps = {
                icon: block.completed ? (
                  <FontAwesomeIcon icon={'check-circle'} />
                ) : (
                  <img alt="Pencil" src={Pencil} />
                ),
                title: `Concept Check (${pluralize(promptCount, 'question')})`,
                action: segmentIsLocked
                  ? () => showUpgradeModal(true)
                  : paths.contentBlockPractice(block.id, {})
              };
            } else if (block.type === 'easy med testlike') {
              const promptCount = Math.min(block.sessionPromptCount, block.blockPromptCount);
              const params = {};
              if (typeof block.difficultyMin === 'number') {
                params['difficulty_min'] = block.difficultyMin;
              }
              if (typeof block.difficultyMax === 'number') {
                params['difficulty_max'] = block.difficultyMax;
              }

              blockProps = {
                icon: block.completed ? (
                  <FontAwesomeIcon icon={'check-circle'} />
                ) : (
                  <img alt="One Diamond" src={SingleDiamond} />
                ),
                title: `Easy and Medium Set (${pluralize(promptCount, 'question')})`,
                action: segmentIsLocked
                  ? () => showUpgradeModal(true)
                  : paths.contentBlockPractice(block.id, params)
              };
            } else if (block.type === 'hard vhard testlike') {
              const promptCount = Math.min(block.sessionPromptCount, block.blockPromptCount);
              const params = {};
              if (typeof block.difficultyMin === 'number') {
                params['difficulty_min'] = block.difficultyMin;
              }
              if (typeof block.difficultyMax === 'number') {
                params['difficulty_max'] = block.difficultyMax;
              }

              blockProps = {
                icon: block.completed ? (
                  <FontAwesomeIcon icon={'check-circle'} />
                ) : (
                  <img alt="Two Diamonds" src={DoubleDiamond} />
                ),
                title: `Hard and Very Hard Set (${pluralize(promptCount, 'question')})`,
                action: segmentIsLocked
                  ? () => showUpgradeModal(true)
                  : paths.contentBlockPractice(block.id, params)
              };
            }

            return (
              <Col key={index} xs={10} className={cx(style.itemContent, 'u-margin-B-xs')}>
                <span
                  className={cx(block.completed && 'text-primary', 'u-margin-R-xs')}
                  style={{ fontSize: '18px' }}>
                  {blockProps.icon}
                </span>
                <div>
                  <p className="u-margin-V-n">
                    {segmentIsLocked ? (
                      <LinkButton onClick={blockProps.action} className={style.darkLink}>
                        {blockProps.title}
                      </LinkButton>
                    ) : (
                      <ContextualLink href={blockProps.action}>{blockProps.title}</ContextualLink>
                    )}
                  </p>
                </div>
              </Col>
            );
          })}
        </Col>
      </Row>
    </div>
  );
};

export default SegmentSlice;
